/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { ChevronsUpDown, LoaderCircle, Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Input } from "@/components/ui/input";
import { InViewComponent } from "@/components/shared/in-view-component";

type ErpSkuProp = {
  placeholder: string;
  value: string;
  emptyListMessage?: string;
  searchLabel?: string;
  showBranchId?: boolean;
  onChange: (prop: string) => void;
  onSearch: (prop: string) => Promise<void>;
  onBlur: () => void;
};

export const AddressMappingList = ({
  placeholder,
  searchLabel,
  emptyListMessage,
  value,
  showBranchId,
  onChange,
  onSearch,
  onBlur,
}: ErpSkuProp) => {
  const [searchText, setSearchText] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [process, setProcess] = React.useState(false);
  const [list, setList] = React.useState<any>([]);

  const onChangeValue = (prop: string) => {
    onChange(prop);
  };

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchText === "") {
        setList([]);
        setProcess(false);
        return;
      }
      setList([]);
      setProcess(true);
      try {
        const response: any = await onSearch(searchText);
        if (response?.data) {
          setList(response.data);
        }
      } finally {
        setProcess(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild onBlur={onBlur}>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="w-full justify-between "
          >
            <span className="flex-1 truncate text-left">
              {value || placeholder || "Select Options..."}
            </span>
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[400px] p-0" align="end">
          <Command>
            <div className="p-1">
              <div className="flex">
                <Button className="absolute" size={"icon"} variant={"ghost"}>
                  <Search />
                </Button>
                <Input
                  className="!outline-none !border-none pl-10 focus:ring-0 focus:ring-offset-0"
                  onChange={(e) => setSearchText(e.target.value)}
                  value={searchText}
                  placeholder={searchLabel || "Search Options"}
                />
              </div>
            </div>

            <CommandList>
              <ConditionRenderer condition={list.length === 0}>
                <ConditionRenderer condition={process}>
                  <div className="flex items-center justify-center">
                    <LoaderCircle className="mr-2 h-6 w-6 animate-spin" />
                  </div>
                  <div className="text-sm px-3 pt-3">
                    {emptyListMessage || "No Options found."}
                  </div>
                </ConditionRenderer>
              </ConditionRenderer>
              <CommandGroup>
                <InViewComponent list={list} pageSize={100}>
                  {(option: any, index) => {
                    // const label = displayOptionsLabel(option);
                    // const isCurrentItemExist = isCurrentOptionIsFiltered(label);
                    // if (!isCurrentItemExist) {
                    //   return null;
                    // }
                    console.log({ option });
                    return (
                      <CommandItem
                        className="text-sm"
                        key={index}
                        value={option}
                        onSelect={() => {
                          onChangeValue(option);
                          setOpen(false);
                        }}
                      >
                        <span className="flex flex-col text-left items-start hover-bg-white">
                          {option.customer_name ? (
                            <span>
                              <b className="text-[#6982a7] font-[500] pr-1">
                                Customer name:
                              </b>
                              {option.customer_name}
                            </span>
                          ) : null}

                          {option.customer_id ? (
                            <span className="">
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Customer id:
                              </b>
                              {option.customer_id}
                            </span>
                          ) : null}

                          {option.branch_name ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Branch name:
                              </b>
                              {option.branch_name}
                            </span>
                          ) : null}

                          {showBranchId && option.branch_id ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Branch id:
                              </b>
                              {option.branch_id}
                            </span>
                          ) : null}

                          {option?.billing_address?.erp_id ? (
                            <span>
                              <b className="text-[#6982a7] font-[500] pr-1">
                                Bill to code:
                              </b>
                              {option?.billing_address?.erp_id}
                            </span>
                          ) : null}
                          {option?.delivery_address?.erp_id ? (
                            <span>
                              <b className="text-[#6982a7] font-[500] pr-1">
                                Ship to code:
                              </b>
                              {option?.delivery_address?.erp_id}
                            </span>
                          ) : null}

                          {option.address1 ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Address 1:
                              </b>
                              {option.address1}
                            </span>
                          ) : null}
                          {option.address2 ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Address 2:
                              </b>
                              {option.address2}
                            </span>
                          ) : null}
                          {option.address2 ? (
                            <span>
                              <b className="text-[#6982a7]  font-[500]  pr-1">
                                Address 2:
                              </b>
                              {option.address2}
                            </span>
                          ) : null}

                          <span>
                            <b className="text-[#6982a7]  font-[500]  pr-1">
                              Route:
                            </b>
                            {option?.delivery_address?.route}
                          </span>
                        </span>
                      </CommandItem>
                    );
                  }}
                </InViewComponent>
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </>
  );
};
